import React from 'react';

interface WordCountModalProps {
  showWordCountModal: boolean;
  onCancel: () => void;
}

const WordCountModal: React.FC<WordCountModalProps> = ({
  showWordCountModal,
  onCancel
}) => {
  if (!showWordCountModal) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onCancel}
    >
      <div 
        className="bg-white rounded-lg p-6 max-w-md w-full mx-4 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <h3 className="text-lg font-medium text-gray-900 mb-4 pr-8">
          Word Count Exceeded
        </h3>
        <p className="text-gray-600 mb-6">
          The word count exceeds the limit.
        </p>
      </div>
    </div>
  );
};

export default WordCountModal; 